import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {Switch, Route} from 'react-router-dom';
import {StationOperatorCreateAlertForm} from '../components';
import PageNotFound from "../../../common/components/PageNotFound";

class StationOperatorAlert extends Component {
	render() {
		const {pageTitle, match} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<Switch>
					<Route exact path={match.url + "/"} component={StationOperatorCreateAlertForm}/>
					<Route component={PageNotFound}/>
				</Switch>
			</Fragment>
		);
	}
}

StationOperatorAlert.defaultProps = {
	pageTitle: 'Alerts'
};

StationOperatorAlert.propTypes = {
	pageTitle: PropTypes.string
};

export default StationOperatorAlert;
